import { deleteApi, getApi, getApiById, postApi, putApi } from "../../Shared/Services/RestService";
import { subscriptionPlanAdminResponse } from "../Types/AdminSubscriptionPlanType";


export const getAllSubscriptionPlansFromAdmin = () => {
  return getApi<subscriptionPlanAdminResponse[]>("/subscriptions");
};

export const getSubscriptionPlanByIdFromAdmin = (id: string ) => {
  return getApiById<subscriptionPlanAdminResponse | null>("/subscriptions", id);
};

export const createSubscriptionPlanFromAdmin = (payload: any) => {
  return postApi<subscriptionPlanAdminResponse>("/subscriptions", payload);
};

export const updateSubscriptionPlanFromAdmin = (payload: any, id: string) => {
  return putApi<subscriptionPlanAdminResponse | null>("/subscriptions", id, payload);
};

export const deleteSubscriptionPlanByIdFromAdmin = (id: string ) => {
  return deleteApi<subscriptionPlanAdminResponse | null>("/subscriptions", id);
};